import { render, staticRenderFns } from "./OrderEmisionGeneralBoardNewRisk.vue?vue&type=template&id=369d6c9a"
import script from "./OrderEmisionGeneralBoardNewRisk.vue?vue&type=script&lang=js"
export * from "./OrderEmisionGeneralBoardNewRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports